import { Plus, Trash2 } from "lucide-react";

const inputCls =
  "w-full bg-transparent border border-ink/20 px-2.5 py-1.5 text-sm outline-none focus:border-ink transition-colors";

let uid = 0;
const newId = () => `btn-${Date.now()}-${uid++}`;

export default function ButtonsEditor({ buttons = [], onChange, lang }) {
  const set = (i, patch) =>
    onChange(buttons.map((b, j) => (j === i ? { ...b, ...patch } : b)));

  const add = () =>
    onChange([
      ...buttons,
      { id: newId(), label: { ro: "Buton", en: "Button" }, href: "#contact", visible: true, style: "solid" },
    ]);

  return (
    <div className="border border-ink/15 p-3">
      <div className="flex items-center justify-between mb-2">
        <span className="eyebrow text-ink/60">Butoane</span>
        <button
          type="button"
          onClick={add}
          data-testid="add-button"
          className="eyebrow inline-flex items-center gap-1 border border-ink px-2 py-1 hover:bg-ink hover:text-paper transition-colors"
        >
          <Plus size={12} /> Adaugă buton
        </button>
      </div>
      <div className="space-y-3">
        {buttons.map((b, i) => (
          <div key={b.id || i} className="border border-ink/10 bg-ink/[0.02] p-2.5 space-y-2">
            <div className="flex items-center justify-between">
              <label className="eyebrow flex items-center gap-2 text-ink/60">
                <input
                  type="checkbox"
                  checked={b.visible !== false}
                  onChange={(e) => set(i, { visible: e.target.checked })}
                />
                Vizibil
              </label>
              <button
                type="button"
                onClick={() => onChange(buttons.filter((_, j) => j !== i))}
                className="p-1 text-red-700 hover:bg-red-700/10"
              >
                <Trash2 size={13} />
              </button>
            </div>
            <label className="block">
              <span className="eyebrow text-ink/40">Text ({lang.toUpperCase()})</span>
              <input
                className={inputCls}
                value={b.label?.[lang] ?? ""}
                onChange={(e) => set(i, { label: { ...b.label, [lang]: e.target.value } })}
                data-testid={`button-label-${i}`}
              />
            </label>
            <div className="grid grid-cols-2 gap-2">
              <label className="block">
                <span className="eyebrow text-ink/40">Link (#sectiune sau URL)</span>
                <input
                  className={inputCls}
                  value={b.href ?? ""}
                  onChange={(e) => set(i, { href: e.target.value })}
                  data-testid={`button-href-${i}`}
                />
              </label>
              <label className="block">
                <span className="eyebrow text-ink/40">Stil</span>
                <select
                  className={inputCls}
                  value={b.style || "solid"}
                  onChange={(e) => set(i, { style: e.target.value })}
                >
                  <option value="solid">Solid</option>
                  <option value="outline">Contur</option>
                </select>
              </label>
            </div>
          </div>
        ))}
        {buttons.length === 0 && <div className="eyebrow text-ink/30 py-2">Niciun buton</div>}
      </div>
    </div>
  );
}
